// Preis-Formatierung des Deck-Editors — identisch zur bisherigen lokalen Kopie der Views.
export function formatPrice(value) {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return '—';
  return `${num.toFixed(2)} €`;
}

// Kartenzahl + Gesamtwert für die ActionBar-Stats (Spec Abschnitt 1, client-seitig).
export function computeDeckTotals(cards) {
  let count = 0;
  let value = 0;
  for (const card of cards || []) {
    const qty = Number(card.quantity) > 0 ? Number(card.quantity) : 1;
    count += qty;
    const price = Number(card.price);
    if (Number.isFinite(price) && price > 0) value += price * qty;
  }
  return { count, value };
}
